import React from 'react';
import { AddSite } from '../../components/AddSite/AddSite';
import { RecordDataIndicators } from '../../components/RecordDataIndicators';
import { useCurrentAppRoute } from '../../hooks/app-route-hooks';
import { isRecordFound, useSelectedOrganizationData } from '../../hooks/data-hooks';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';

export const AddSiteContainer: React.FC = () => {
    const selectedOrganization = useSelectedOrganizationData();
    const { t } = useLanguageLocale();
    const currentAppRoute = useCurrentAppRoute()
    return (
        <>
            <RecordDataIndicators
                recordData={selectedOrganization}
                errorMessage={t('DASHBOARD.ERROR_LOADING_ORGANIZATION')}
                notFoundIcon="Business"
                notFoundMessage={t('DASHBOARD.ORGANIZATION_NOT_FOUND')}
            />

            {isRecordFound(selectedOrganization) && 'locationId' in currentAppRoute &&
                
                <AddSite testId="location-profile-add-site-page"
                appRoute={{ type: 'LocationProfile', orgId: selectedOrganization.value.id, locationId: currentAppRoute.locationId }} />
           
            }
        </>
    )
}
